/** Whether a persisted `LlmRequest.options` JSON string requested the web-search tool. */
export function didUseWebSearch(options: string | null | undefined): boolean {
  if (!options) return false;
  try {
    return Boolean(JSON.parse(options).useWebSearch);
  } catch {
    return false;
  }
}
